module.exports = __webpack_public_path__ + "images/tour-3d-2-a9be753342c9edf900e47160eb873595.jpg";